/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Entra_Step3Inputs */



/**
* | output |
* | --- |
* | "Go to Provisioning and set mode to Automatic" |
*
* @param {Scim_Setup_Entra_Step3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_entra_step3 = /** @type {((inputs?: Scim_Setup_Entra_Step3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Entra_Step3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gehen Sie zu Bereitstellung und setzen Sie den Modus auf Automatisch")
	return /** @type {LocalizedString} */ ("Go to Provisioning and set mode to Automatic")
});